import Component from '@glimmer/component';
import { PrismIllustration, PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import { CENTRAL_MAPPING_HELP_CENTER_LINKS } from 'lumen/utils/central-mapping-constants';

import styles from './modal-hierarchy-onboarding.module.css';
interface SettingsCentralMappingModalsModalHierarchyOnboardingSignature {
  Args: {
    onClose: () => void;
  };
}
export default class SettingsCentralMappingModalsModalHierarchyOnboarding extends Component<SettingsCentralMappingModalsModalHierarchyOnboardingSignature> {
  hierarchHelpCenterLink = CENTRAL_MAPPING_HELP_CENTER_LINKS.HIERARCHY_PAGE;

  <template>
    <PrismModal
      @onClose={{@onClose}}
      class={{styles.onboarding-modal}}
      data-test-id="central-mapping-hierarchy-onboarding-modal"
    >
      <:headerContent>
        <h3
          class="flex w-full items-center justify-center pl-1000"
          data-test-id="central-mapping-hierarchy-onboarding-modal-header"
        >
          {{t "settings.central_mapping.onboarding.hierarchy.header"}}
        </h3>
      </:headerContent>

      <:default>
        <section
          class={{styles.body}}
          data-test-id="central-mapping-hierarchy-onboarding-modal-content"
        >
          <PrismIllustration
            @name="200x200_custom-hierarchy"
            @size="unsafe_unconstrained"
          />

          <p class="paragraph-300--regular">{{t
              "settings.central_mapping.onboarding.hierarchy.description"
            }}</p>

          <GeneralNavigationIntercomHelpLink
            @articleLink={{this.hierarchHelpCenterLink}}
            @iconName="book"
            @iconPlacement="before"
            @isStandaloneLink={{true}}
            @linkText={{t
              "settings.central_mapping.onboarding.hierarchy.link_text"
            }}
            @textSize="small"
            @type="text-and-icon"
            data-test-id="help-center-button"
          />
        </section>
      </:default>
    </PrismModal>
  </template>
}
